module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG81b2d6d9eb5e06b85cd8af3f28f98fb9.81b2d6d9.png";